module.exports = __webpack_public_path__ + "img/recharge-tree-img.485a3fa7.png";